export let settings = [
	{
		id: 'building',
		label: 'Building Size',
		fields: [
			{
				id: 'width',
				label: 'Width',
				value: 30,
				min: 10,
				max: 100,
				step: 1,
				units: 'ft.',
				type: 'slider'
			},
			{
				id: 'length',
				label: 'Length',
				value: 60,
				min: 10,
				max: 200,
				step: 1,
				units: 'ft.',
				type: 'slider'
			},
			{
				id: 'height',
				label: 'Height',
				value: 16,
				min: 5,
				max: 24,
				step: 1,
				units: 'ft.',
				type: 'slider'
			},
			{
				id: 'pitch',
				label: 'Pitch',
				value: 1,
				min: 1,
				max: 5,
				step: 1,
				units: '/12',
				type: 'slider'
			},
			{
				id: 'single_slope',
				label: 'Single slope',
				value: false,
				type: 'toggle'
			}
		]
	},
	{
		id: 'overhangs',
		label: 'Overhangs',
		fields: [
			{
				id: 'overhang_sides',
				label: 'Sides',
				value: 0,
				min: 0,
				max: 5,
				units: 'ft.',
				type: 'slider'
			},
			{
				id: 'overhang_ends',
				label: 'End',
				value: 0,
				min: 0,
				max: 5,
				units: 'ft.',
				type: 'slider'
			}
		]
	},
	{
		id: 'front',
		label: 'Front Face',
		fields: [
			{
				id: 'additions',
				label: 'Addition',
				value: [],
				type: 'multi_select'
			},
			{
				id: 'lean_to_enable',
				label: 'Enable Lean To',
				value: false,
				type: 'lean_to_toggle'
			},
			{
				id: 'lean_to_length',
				label: 'Length',
				value: 10,
				min: 6,
				max: 25,
				step: 1,
				units: 'ft.',
				type: 'lean_to_slider'
			},
			{
				id: 'lean_to_pitch',
				label: 'Pitch',
				value: 1,
				min: 1,
				max: 5,
				step: 1,
				units: '/12',
				type: 'lean_to_slider'
			},
			{
				id: 'lean_to_drop',
				label: 'Drop',
				value: 1,
				min: 1,
				max: 20,
				step: 1,
				units: 'ft.',
				type: 'lean_to_slider'
			},
			{
				id: 'lean_to_cut_1',
				label: 'Cut 1',
				value: 0,
				min: 0,
				max: 100,
				step: 1,
				units: 'ft.',
				type: 'lean_to_slider'
			},
			{
				id: 'lean_to_cut_2',
				label: 'Cut 2',
				value: 0,
				min: 0,
				max: 100,
				step: 1,
				units: 'ft.',
				type: 'lean_to_slider'
			}
		]
	},
	{
		id: 'left',
		label: 'Left Face',
		fields: [
			{
				id: 'additions',
				label: 'Addition',
				value: [],
				type: 'multi_select'
			},
			{
				id: 'lean_to_enable',
				label: 'Enable Lean To',
				value: false,
				type: 'lean_to_toggle'
			},
			{
				id: 'lean_to_length',
				label: 'Length',
				value: 10,
				min: 6,
				max: 25,
				step: 1,
				units: 'ft.',
				type: 'lean_to_slider'
			},
			{
				id: 'lean_to_pitch',
				label: 'Pitch',
				value: 1,
				min: 1,
				max: 5,
				step: 1,
				units: '/12',
				type: 'lean_to_slider'
			},
			{
				id: 'lean_to_drop',
				label: 'Drop',
				value: 1,
				min: 1,
				max: 20,
				step: 1,
				units: 'ft.',
				type: 'lean_to_slider'
			},
			{
				id: 'lean_to_cut_1',
				label: 'Cut 1',
				value: 0,
				min: 0,
				max: 100,
				step: 1,
				units: 'ft.',
				type: 'lean_to_slider'
			},
			{
				id: 'lean_to_cut_2',
				label: 'Cut 2',
				value: 0,
				min: 0,
				max: 100,
				step: 1,
				units: 'ft.',
				type: 'lean_to_slider'
			}
		]
	},
	{
		id: 'back',
		label: 'Back Face',
		fields: [
			{
				id: 'additions',
				label: 'Addition',
				value: [],
				type: 'multi_select'
			},
			{
				id: 'lean_to_enable',
				label: 'Enable Lean To',
				value: false,
				type: 'lean_to_toggle'
			},
			{
				id: 'lean_to_length',
				label: 'Length',
				value: 10,
				min: 6,
				max: 25,
				step: 1,
				units: 'ft.',
				type: 'lean_to_slider'
			},
			{
				id: 'lean_to_pitch',
				label: 'Pitch',
				value: 1,
				min: 1,
				max: 5,
				step: 1,
				units: '/12',
				type: 'lean_to_slider'
			},
			{
				id: 'lean_to_drop',
				label: 'Drop',
				value: 1,
				min: 1,
				max: 20,
				step: 1,
				units: 'ft.',
				type: 'lean_to_slider'
			},
			{
				id: 'lean_to_cut_1',
				label: 'Cut 1',
				value: 0,
				min: 0,
				max: 100,
				step: 1,
				units: 'ft.',
				type: 'lean_to_slider'
			},
			{
				id: 'lean_to_cut_2',
				label: 'Cut 2',
				value: 0,
				min: 0,
				max: 100,
				step: 1,
				units: 'ft.',
				type: 'lean_to_slider'
			}
		]
	},
	{
		id: 'right',
		label: 'Right Face',
		fields: [
			{
				id: 'additions',
				label: 'Addition',
				value: [],
				type: 'multi_select'
			},
			{
				id: 'lean_to_enable',
				label: 'Enable Lean To',
				value: false,
				type: 'lean_to_toggle'
			},
			{
				id: 'lean_to_length',
				label: 'Length',
				value: 10,
				min: 6,
				max: 25,
				step: 1,
				units: 'ft.',
				type: 'lean_to_slider'
			},
			{
				id: 'lean_to_pitch',
				label: 'Pitch',
				value: 1,
				min: 1,
				max: 5,
				step: 1,
				units: '/12',
				type: 'lean_to_slider'
			},
			{
				id: 'lean_to_drop',
				label: 'Drop',
				value: 1,
				min: 1,
				max: 20,
				step: 1,
				units: 'ft.',
				type: 'lean_to_slider'
			},
			{
				id: 'lean_to_cut_1',
				label: 'Cut 1',
				value: 0,
				min: 0,
				max: 100,
				step: 1,
				units: 'ft.',
				type: 'lean_to_slider'
			},
			{
				id: 'lean_to_cut_2',
				label: 'Cut 2',
				value: 0,
				min: 0,
				max: 100,
				step: 1,
				units: 'ft.',
				type: 'lean_to_slider'
			}
		]
	},
	{
		id: 'lean_to_wrap',
		fields: [
			{
				id: 'front_left',
				value: false
			},
			{
				id: 'front_right',
				value: false
			},
			{
				id: 'back_left',
				value: false
			},
			{
				id: 'back_right',
				value: false
			}
		]
	},
	{
		id: 'colors',
		label: 'Color Selections',
		fields: [
			{
				id: 'color_wall',
				type: 'color',
				label: 'Wall',
				value: '#b59480'
			},
			{
				id: 'color_roof',
				type: 'color',
				label: 'Roof',
				value: '#d5d0d7'
			},
			{
				id: 'color_trim',
				type: 'color',
				label: 'Trim',
				value: '#504541'
			},
			{
				id: 'color_rollup',
				type: 'color',
				label: 'Rollup',
				value: '#d5d0d7'
			}
		]
	},
	{
		id: 'ridge_vent',
		label: 'Ridge Vent',
		fields: [
			{
				id: 'ridge_vent_type',
				label: 'Type',
				value: 'none',
				values: [
					{
						id: 'none',
						label: 'None'
					},
					{
						id: 'standard',
						label: 'Standard'
					},
					{
						id: 'low',
						label: 'Low'
					}
				],
				type: 'select'
			},
			{
				id: 'ridge_vent_mode',
				label: 'Mode',
				value: 'continuous',
				values: [
					{
						id: 'continuous',
						label: 'Continuous'
					},
					{
						id: 'even',
						label: 'Evenly Spread'
					}
				],
				disabled: true,
				type: 'select'
			},
			{
				id: 'color_vent',
				type: 'color',
				label: 'Vent Color',
				value: '#d5d0d7'
			}
		]
	},
	{
		id: 'building_options',
		label: 'Building Options',
		fields: [
			{
				id: 'gutters',
				label: 'Gutters',
				value: false,
				type: 'toggle'
			},
			{
				id: 'wainscot',
				label: 'Wainscot',
				value: false,
				type: 'toggle'
			},
			{
				id: 'color_wainscot',
				type: 'color',
				label: 'Wainscot Color',
				value: '#d5d0d7'
			}
		]
	},
	{
		id: 'contact',
		label: 'Contact Information',
		fields: [
			{
				id: 'name',
				label: 'Name',
				value: '',
				type: 'text',
				required: true
			},
			{
				id: 'email',
				label: 'Email',
				value: '',
				type: 'text',
				required: true
			},
			{
				id: 'phone',
				label: 'Phone Number',
				value: '',
				type: 'text',
				required: true
			},
			{
				id: 'zip',
				label: 'Zip Code',
				value: '',
				type: 'text',
				required: true
			},
			{
				id: 'building_type',
				label: 'Building Type *',
				value: '',
				values: [
					{
						id: 'weld_up',
						label: 'Weld Up'
					},
					{
						id: 'bolt_up',
						label: 'Bolt Up'
					}
				],
				type: 'select',
				required: true
			}
		]
	}
];
